var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-vue-table',{ref:"table",staticClass:"pl-3 pr-3",attrs:{"showSearchBox":false,"title":"Notifications","url":_vm.listUrl,"fields":_vm.fields,"per-page":10}})}
var staticRenderFns = []

export { render, staticRenderFns }